import Colors from 'enums/Colors';
import { Description } from 'pages/biblioteca_v2/components/categoria-item/DefaultItem.styled';
import styled from 'styled-components';

const FVContentsStyled = {
    Container: styled.div`
        display: grid;
        grid-template-columns: 780px 340px;
        gap: 16px;


        @media screen and (max-width: 1170px) {
            grid-template-columns: 1fr;
        }
    `,

    Content: styled.div<{ gap?: string }>`
        display: flex;
        flex-direction: column;
        gap: ${props => props.gap || '48px'};
    `,

    Title: styled.h1<{ color?: string; colorSpan?: string }>`
        display: flex;
        flex-wrap: wrap;
        font-family: 'Barlow';
        font-weight: 700;
        font-style: Bold;
        font-size: 40px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        gap: 1rem;

        color: ${props => props.color || Colors.White};
    `,

    TitleVideo: styled.h1<{ color?: string; colorSpan?: string }>`
        display: flex;
        flex-direction: column;
        font-family: 'Barlow';
        font-weight: 700;
        font-style: Bold;
        font-size: 28px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        gap: 0.2rem;

        color: ${props => props.color || Colors.White};

        span {
            color: ${props => props.colorSpan || Colors.Yellow};
        }
    `,

    DescriptionVideo: styled.h1<{ color?: string }>`
        font-family: 'Barlow';
        font-weight: 500;
        font-style: Medium;
        font-size: 24px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;

        color: ${props => props.color || Colors.White};
    `,

    Video: {
        Container: styled.div<{ img?: string }>`
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url(${props => props.img});
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;

            font-size: 24px;
            height: 498px;
            background-color: #00000055;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.7);
                pointer-events: none;
                z-index: 1;
            }

            > * {
                position: relative;
                z-index: 2;
            }
        `,
    },

    Button: styled.button`
        background: linear-gradient(90deg, #ffb300 0%, #ffcb3a 100%);
        color: #003c78;
        font-weight: bold;
        font-size: 1.1rem;
        border: none;
        border-radius: 6px;
        padding: 12px 0;
        margin-top: 12px;
        cursor: pointer;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
        transition: background 0.2s, color 0.2s;
        text-transform: uppercase;
        max-width: 260px;
        &:hover {
            background: linear-gradient(90deg, #ffcb3a 0%, #ffb300 100%);
            color: #00264d;
        }
    `,

    Form: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },

    VideoPreview: {
        Container: styled.div`
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 498px;
            background-color: #00000055;

            video {
                width: 100%;
                height: 100%;
                background-color: black;
            }
        `,

        ButtonUploadVideo: styled.button`
            position: absolute;
            top: 10px;
            right: 70px;
            height: 40px;
            z-index: 2;
            border: none;
            background: linear-gradient(90deg, #ffb300 0%, #ffcb3a 100%);
        `,

        Thumbnail: styled.div<{ active: boolean }>`
            display: flex;
            position: relative;
            width: 100%;
            height: 120px;
            font-family: 'Roboto';
            font-weight: 700;
            font-style: Bold;
            font-size: 20px;
            letter-spacing: 0%;
            transition: all 0.3s ease-in-out;
            cursor: pointer;

            background-color: ${props => (props.active ? '#00000d10' : 'transparent')};

            img {
                width: 168px;
                object-fit: fill;
            }

            h1 {
                color: ${Colors.Yellow};
                padding: 0;
                margin: 0;
            }

            h2 {
                font-weight: 400;
                font-size: 20px;
                letter-spacing: 0%;
                line-height: 28px;
                color: ${Colors.White};
                height: 80px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3; /* number of lines to show */
                -webkit-box-orient: vertical;
            }

            &:hover {
                transform: scale(1.05);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            }
        `,

        TagPlay: styled.div`
            position: absolute;
            top: 5px;
            font-size: 14px;
            right: 10px;
            background-color: ${Colors.Yellow};
            color: ${Colors.Blue};
            padding: 2px;
            z-index: 2;
        `,

        TagMinutagem: styled.div`
            position: absolute;
            bottom: 5px;
            width: 35;
            height: 18;
            opacity: 1;
            padding-top: 3px;
            padding-right: 4px;
            padding-bottom: 3px;
            padding-left: 4px;
            gap: 10px;
            background-color: ${Colors.Yellow};
            color: ${Colors.Blue};

            font-family: 'Roboto';
            font-weight: 900;
            font-style: Black;
            font-size: 10px;
            line-height: 100%;
            letter-spacing: 0%;

            z-index: 2;
        `,
    },

    Row: styled.div`
        display: flex;
        gap: 40px;
    `,
};

export default FVContentsStyled;
